
import Header from "@/components/header/Header.vue";

export default {
  components: {
    Header,
  },
};
